<template>
    <div class="mc-menu-divider" />
</template>

<style scoped lang="scss">
.mc-menu-divider {
    height: 1px;
    background: var(--mc-line-hard);
}
</style>
